<template>
  <div class="errors-info-wrapper spacex-8">
    <Badge color="accent" rounded>{{ allErrorsCount }}</Badge>
    <div class="spacex-20">
      <span class="text-sm">
        {{ $tc('Resolve validation-alerts to import your bill of quantities', allErrorsCount) }}
      </span>
      <Button type="secondary" size="small" @click.native="openErrorsPopup">
        {{ $t('Show all') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import Button from '@/components/ui-v2/Button';
  import { mapActions } from 'vuex';
  import ImportErrorsModal from '@/components/import/validation-alerts/ImportErrorsModal';

  export default {
    name: 'ErrorsAlert',
    components: {
      Button,
      Badge,
    },
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      allErrorsCount() {
        return this.errors.reduce((total, currentElem) => total + currentElem.errors.length, 0);
      },
    },
    methods: {
      ...mapActions('modal', ['openModal']),
      openErrorsPopup() {
        this.openModal({
          component: ImportErrorsModal,
          context: {
            errors: this.errors,
            allErrorsCount: this.allErrorsCount,
          },
        });
      },
    },
  };
</script>
